import { useSession } from '@nextgen-web-framework/all';
import { useEffect } from 'react';

const DynatraceSetup = () => {
  const config = ConfigService.getConfigs();
  const { session, isAnonymous } = useSession();

  useEffect(() => {
    // Skip if session not present, or anonymous user or tracking disabled
    if (!window.dtrum?.identifyUser || !session || isAnonymous()) {
      return;
    }

    const user = {
      partyId: `${session.partyId}`,
      aboNumber: `${(config.NEXT_PUBLIC_TENANT as number) * 100000000000 + Number(session.aboNum ?? 0)}`,
    };

    window.dtrum.identifyUser(user.aboNumber, {
      partyId: user.partyId,
    });
  }, [session, isAnonymous, config]);

  return null;
};

export default DynatraceSetup;
